<template>
  <hm-content class="micro-goods-list">
    <div class="mb10 flex flex-start">
      <el-radio-group v-model="activeTab" size="small" class="mr10" @change="switchTabs">
        <el-radio-button label="0">自己的售后</el-radio-button>
        <el-radio-button label="1">三方的售后</el-radio-button>
      </el-radio-group>
    </div>
    <div class="mb10 flex flex-start">
      <el-radio-group
        v-if="activeTab == 0"
        v-model="searchCondition.status"
        size="small"
        @change="switchTabs"
      >
        <el-radio-button label="1"
          >待审核({{ orderReturnList.applyNum }})</el-radio-button
        >
        <el-radio-button label="2"
          >待退款({{ orderReturnList.agreeNum }})</el-radio-button
        >
        <el-radio-button label="4"
          >已退款({{ orderReturnList.payNum }})</el-radio-button
        >
        <el-radio-button label="8"
          >已驳回({{ orderReturnList.refuseNum }})</el-radio-button
        >
        <el-radio-button label="5"
          >未确认({{ orderReturnList.customerApplyNum }})</el-radio-button
        >
        <el-radio-button label="0"
          >全部({{ orderReturnList.allNum }})</el-radio-button
        >
      </el-radio-group>
      <el-radio-group
              v-if="activeTab == 1"
              v-model="searchCondition.status"
              size="small"
              @change="switchTabs"
      >
        <el-radio-button label="1"
        >待审核({{ orderReturnList.applyNum }})</el-radio-button
        >
        <el-radio-button label="2"
        >待退款({{ orderReturnList.agreeNum }})</el-radio-button
        >
        <el-radio-button label="4"
        >已退款({{ orderReturnList.payNum }})</el-radio-button
        >
        <el-radio-button label="8"
        >已驳回({{ orderReturnList.refuseNum }})</el-radio-button
        >
        <el-radio-button label="5"
        >未确认({{ orderReturnList.customerApplyNum }})</el-radio-button
        >
        <el-radio-button label="0"
        >全部({{ orderReturnList.allNum }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <div class="table-panel flex flex-wrap flex-end" v-if="activeTab == 0" >
      <el-select
        clearable
        v-model="searchCondition.shopId"
        placeholder="请选择门店"
        size="small"
        filterable
        class="mr10"
        v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
      >
        <el-option
          :label="v.shopName"
          :value="v.shopId"
          v-for="(v, i) in microShopStoreList"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
          clearable
          v-model="searchCondition.shopId"
          placeholder="请选择门店"
          size="small"
          filterable
          class="mr10"
          v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
      >
        <el-option
            :label="v.shopName"
            :value="v.shopId"
            v-for="(v, i) in dkShops"
            :key="i"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.returnType"
        placeholder="请选择退款方式"
        size="small"
        class="mr10"
      >
        <el-option label="仅退款" value="money"></el-option>
        <el-option label="退运费" value="deliver"></el-option>
        <el-option label="退货退款" value="refund"></el-option>
      </el-select>
      <!-- <el-select
        clearable
        v-model="searchCondition.status"
        placeholder="请选择退款状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="已提交" value="1"></el-option>
        <el-option label="已审核" value="2"></el-option>
        <el-option label="已退货待退款" value="3"></el-option>
        <el-option label="已退款" value="4"></el-option>
        <el-option label="已驳回" value="8"></el-option>
        <el-option label="已取消" value="9"></el-option>
      </el-select> -->
      <el-select
        v-model="searchCondition.queryTimeType"
        size="small"
        style="width:101px;marginLeft:4px"
        class="time-type"
        filterable
      >
        <el-option label="申请时间" value="returnSendTime"></el-option>
        <el-option label="退款时间" value="refundTime"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.mopWriteState"
        placeholder="是否退单写入MOP"
        size="small"
        class="mr10"
      >
        <el-option label="已写入成功" value="success"></el-option>
        <el-option label="写入失败" value="fail"></el-option>
      </el-select>
      <el-date-picker
        v-model="searchCondition.applyDate"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        align="right"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10 time"
      ></el-date-picker>
      <el-input
        style="width:200px"
        class="mr10"
        clearable
        v-model.trim="searchCondition.queryKey"
        placeholder="请输入退款编号/订单号"
        size="small"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
    </div>
    <div class="table-panel flex flex-wrap flex-end" v-if="activeTab == 1" >
      <el-select
          clearable
          v-model="searchCondition.shopId"
          placeholder="请选择门店"
          size="small"
          filterable
          class="mr10"
          v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
      >
        <el-option
            :label="v.shopName"
            :value="v.shopId"
            v-for="(v, i) in microShopStoreList"
            :key="i"
        ></el-option>
      </el-select>
      <el-select
          clearable
          v-model="searchCondition.shopId"
          placeholder="请选择门店"
          size="small"
          filterable
          class="mr10"
          v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
      >
        <el-option
            :label="v.shopName"
            :value="v.shopId"
            v-for="(v, i) in dkShops"
            :key="i"
        ></el-option>
      </el-select>
      <el-select
              clearable
              v-model="searchCondition.returnType"
              placeholder="请选择退款方式"
              size="small"
              class="mr10"
      >
        <el-option label="仅退款" value="money"></el-option>
        <el-option label="退运费" value="deliver"></el-option>
        <el-option label="退货退款" value="refund"></el-option>
      </el-select>
      <!-- <el-select
        clearable
        v-model="searchCondition.status"
        placeholder="请选择退款状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="已提交" value="1"></el-option>
        <el-option label="已审核" value="2"></el-option>
        <el-option label="已退货待退款" value="3"></el-option>
        <el-option label="已退款" value="4"></el-option>
        <el-option label="已驳回" value="8"></el-option>
        <el-option label="已取消" value="9"></el-option>
      </el-select> -->
      <el-select
              v-model="searchCondition.queryTimeType"
              size="small"
              style="width:101px;marginLeft:4px"
              class="time-type"
              filterable
      >
        <el-option label="申请时间" value="returnSendTime"></el-option>
        <el-option label="退款时间" value="refundTime"></el-option>
      </el-select>
              <el-select
                      clearable
                      v-model="searchCondition.mopWriteState"
                      placeholder="是否退单写入MOP"
                      size="small"
                      class="mr10"
              >
                <el-option label="已写入成功" value="success"></el-option>
                <el-option label="写入失败" value="fail"></el-option>
              </el-select>
      <el-date-picker
              v-model="searchCondition.applyDate"
              :default-time="['00:00:00', '23:59:59']"
              type="datetimerange"
              align="right"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10 time"
      ></el-date-picker>
      <el-input
              style="width:200px"
              class="mr10"
              clearable
              v-model.trim="searchCondition.queryKey"
              placeholder="请输入退款编号/订单号"
              size="small"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
              type="success"
              size="small"
              @click="output"
              :loading="isOutputing"
      >导出</el-button
      >
      <el-button type="info" size="small" @click="searchCondition = {}"
      >重置</el-button
      >
    </div>
    <div class="table">
      <el-table
              :key="Math.random()"
        v-if="activeTab == 0"
        stripe
        border
        show-summary
        ref="brandTable"
        @selection-change="getChecked"
        :data="orderReturnList.storeOrderBasicInfoModelPage.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnSn"
          label="退款编码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnType"
          label="退款方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.returnType === 'money'">仅退款</span>
            <span v-else-if="scope.row.returnType === 'refund'">退货退款 </span>
            <span v-else-if="scope.row.returnType === 'deliver'">退运费 </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="订单编号"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="商品名称">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.spuName"
              placement="top"
            >
              <div class="flex item-center">
                <!-- <span class="pos" v-if="scope.row.createMode">
                  p
                </span> -->
                <span class="time flex-1 text-overflow">
                  {{ scope.row.spuName }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="商品编码">
          <template slot-scope="scope">
            <span>{{ scope.row.goodsSn }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="商品条码">
          <template slot-scope="scope">
            <span>{{ scope.row.barCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnAmount"
          label="申请退款金额"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.returnAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="confirmReturnAmount"
          label="核定退款金额"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.confirmReturnAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnDeliverMoney"
          label="运费退款申请"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.returnDeliverMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="confirmReturnDeliverMoney"
          label="运费退款核定"
        >
          <template slot-scope="scope">
            <span class="danger"
              >¥{{ scope.row.confirmReturnDeliverMoney }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnPackageMoney"
          label="包装费退款申请"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.returnPackageMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="confirmReturnPackageMoney"
          label="包装费退款核定"
        >
          <template slot-scope="scope">
            <span class="danger"
              >¥{{ scope.row.confirmReturnPackageMoney }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnSendTime"
          label="申请时间"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="退款状态">
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.status === 1">已提交</span>
            <span class="danger" v-if="scope.row.status === 2">已审核</span>
            <span class="danger" v-if="scope.row.status === 3"
              >已退货待退款</span
            >
            <span class="blue" v-if="scope.row.status === 4">已退款</span>
            <span class="gray" v-if="scope.row.status === 5">待确认</span>
            <span class="danger" v-if="scope.row.status === 8">已驳回</span>
            <span class="gray" v-if="scope.row.status === 9">已取消</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="是否退单写入MOP">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.mopWriteState === 'success'">已写入成功</span>
            <span class="danger" v-else-if="scope.row.mopWriteState === 'fail'">写入失败</span>
            <span class="gray" v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnReason"
          label="退款原因"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="退款类型">
          <span>售后申请 </span>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="所属门店"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <!-- <el-tooltip class="item" content="删除" placement="top">
                <div class="pointer mr10" @click="removes(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
              :key="Math.random()"
              v-if="activeTab == 1"
              stripe
              border
              show-summary
              ref="brandTable"
              @selection-change="getChecked"
              :data="orderReturnList.storeOrderBasicInfoModelPage.records"
              style="width: 100%"
              id="table"
              size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
                type="index"
                label="序号"
                :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="returnSn"
                label="退款编码"
        ></el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="returnType"
                label="退款方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.returnType === 'money'">仅退款</span>
            <span v-else-if="scope.row.returnType === 'refund'">退货退款 </span>
            <span v-else-if="scope.row.returnType === 'deliver'">退运费 </span>
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单编号"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="商品名称">
          <template slot-scope="scope">
            <el-tooltip
                    class="item"
                    :content="scope.row.spuName"
                    placement="top"
            >
              <div class="flex item-center">
                <!-- <span class="pos" v-if="scope.row.createMode">
                  p
                </span> -->
                <span class="time flex-1 text-overflow">
                  {{ scope.row.spuName }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="商品编码">
          <template slot-scope="scope">
            <span>{{ scope.row.goodsSn }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="商品条码">
          <template slot-scope="scope">
            <span>{{ scope.row.barCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="returnAmount"
                label="申请退款金额"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.returnAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="confirmReturnAmount"
                label="核定退款金额"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.confirmReturnAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="returnDeliverMoney"
                label="运费退款申请"
        >
          <template slot-scope="scope">
            <span class="danger">¥{{ scope.row.returnDeliverMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="confirmReturnDeliverMoney"
                label="运费退款核定"
        >
          <template slot-scope="scope">
            <span class="danger"
            >¥{{ scope.row.confirmReturnDeliverMoney }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="returnSendTime"
                label="申请时间"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="退款状态">
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.status === 1">已提交</span>
            <span class="danger" v-if="scope.row.status === 2">已审核</span>
            <span class="danger" v-if="scope.row.status === 3"
            >已退货待退款</span
            >
            <span class="blue" v-if="scope.row.status === 4">已退款</span>
            <span class="gray" v-if="scope.row.status === 5">待确认</span>
            <span class="danger" v-if="scope.row.status === 8">已驳回</span>
            <span class="gray" v-if="scope.row.status === 9">已取消</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="是否退单写入MOP">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.mopWriteState === 'success'">已写入成功</span>
            <span class="danger" v-else-if="scope.row.mopWriteState === 'fail'">写入失败</span>
            <span class="gray" v-else></span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="退款类型">
          <span>售后申请 </span>
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="所属门店"
        ></el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="supplierName"
                label="所属供货商"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <!-- <el-tooltip class="item" content="删除" placement="top">
                <div class="pointer mr10" @click="removes(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination" v-if="activeTab == 0" >
      <el-pagination
        background
        :total="orderReturnList.storeOrderBasicInfoModelPage.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <div class="hm-pagination" v-if="activeTab == 1" >
      <el-pagination
              background
              :total="orderReturnList.storeOrderBasicInfoModelPage.total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
              :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      width="95%"
      :visible.sync="dialogVisible"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
        <span class="form-item-tip" style="color: #fF0000"
          >当前订单状态：{{ orderSta }}</span
        >
      </div>
      <div class="content">
        <div class="flex mt10">
          <!-- <ul class="info-list flex-1">
            <li class="mb20">
              <div class="title">基本信息</div>
              <div class="mb20">
                <el-table
                  stripe
                  border
                  :data="[detailsorderReturn.orderInfo]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiptSn"
                    label="订单编号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="orderState"
                    label="订单状态"
                  >
                    <template
                      slot-scope="scope"
                      v-if="detailsorderReturn.orderInfo"
                    >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'createOrder'"
                        >创建订单</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'payOrder'"
                        >订单支付</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'deliverOrder'"
                        >订单发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'takeOrder'"
                        >确认收货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'pushOrder'"
                        >完成评论</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'delOrder'"
                        >订单取消</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderState === 'returnOrder'"
                        >售后订单</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="actuallyPrice"
                    label="订单金额"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="payMode"
                    label="退货数量"
                  >
                    <template v-if="detailsorderReturn.returnOrder">
                      <span>{{
                        detailsorderReturn.returnOrder.returnNumber
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="returnAmount"
                    label="申请退款金额"
                  >
                    <template v-if="detailsorderReturn.returnOrder">
                      <span>{{
                        detailsorderReturn.returnOrder.returnAmount
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="200"
                    prop="actuallyPrice"
                    label="确认退款金额"
                  >
                    <template v-if="detailsorderReturn.returnOrder">
                      <el-input
                        clearable
                        type="number"
                        @mousewheel.prevent.native
                        :disabled="disabled || show"
                        style="width:150px;"
                        v-model.trim="
                          detailsorderReturn.returnOrder.confirmReturnAmount
                        "
                        placeholder="请输入确认退款金额"
                        size="small"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="mb20">
                <el-table
                  stripe
                  border
                  :data="[detailsorderReturn.orderInfo]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverName"
                    label="退货申请人"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberMobile"
                    label="电话"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="returnReason"
                    label="退货原因"
                  >
                    <template v-if="detailsorderReturn.returnOrder">
                      <span>{{
                        detailsorderReturn.returnOrder.returnReason
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="returnSendTime"
                    label="申请时间"
                  >
                    <span v-if="detailsorderReturn.returnOrder">
                      {{ detailsorderReturn.returnOrder.returnSendTime }}
                    </span>
                  </el-table-column>
                </el-table>
              </div>
            </li>
            <li class="mb20">
              <el-table
                border
                :data="detailsorderReturn.goodsList"
                size="small"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsImg"
                  label="商品图片"
                >
                  <template slot-scope="scope">
                    <div>
                      <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                      />
                      <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                      />

                      <img
                        style="width:100px;height:100px;"
                        v-if="scope.row.goodsImg"
                        :src="scope.row.goodsImg"
                        alt=""
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="商品名称/品牌"
                >
                  <template slot-scope="scope">
                    <p>{{ scope.row.spuName }}</p>
                    <p>品牌: {{ scope.row.brandName }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="价格/货号"
                >
                  <template slot-scope="scope">
                    <p>价格: {{ scope.row.totalPrice }}</p>
                    <p v-if="scope.row.goodsSn">货号: {{ scope.row.goodsSn }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="净重/毛重"
                >
                  <template slot-scope="scope">
                    <p v-if="scope.row.netWeight">
                      净重: {{ scope.row.netWeight }}
                    </p>
                    <p v-if="scope.row.grossWeight">
                      毛重: {{ scope.row.grossWeight }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop=""
                  label="规格"
                >
                  ---
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="数量"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="小计"
                >
                  <template slot-scope="scope">
                    <p>￥{{ scope.row.totalPrice * scope.row.goodsNum }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </li>
            <li class="mb20">
              <div class="title">收货人信息</div>
              <el-table
                stripe
                border
                :data="[detailsorderReturn.orderInfo]"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiverName"
                  label="收货人"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiverMobile"
                  label="手机号码"
                >
                </el-table-column>

                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="收货地址"
                >
                  <template
                    slot-scope="scope"
                    v-if="detailsorderReturn.orderInfo"
                  >
                    <span>
                      {{ scope.row.deliveryProvince
                      }}{{ scope.row.deliveryAddress }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </li>
            <li class="mb20">
              <div class="title">操作信息</div>
              <el-table
                stripe
                border
                :data="detailsorderReturn.status"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="operator"
                  label="操作者"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="val"
                  label="操作"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="time"
                  label="操作时间"
                ></el-table-column>
              </el-table>
            </li>
          </ul> -->
          <ul class="info-list flex-1" style="width:50%">
            <div style="paddingLeft:10px">
              <li class="mb20">
                <div class="title">基本信息</div>
                <div class="mb20">
                  <el-table
                    stripe
                    border
                    :data="[detailsOrder.order]"
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="receiptSn"
                      label="订单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="发货单流水号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="memberMobile"
                      label="会员手机号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="payMode"
                      label="支付方式"
                    >
                      <template slot-scope="scope">
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'no_pay'"
                          >未支付</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === '0_pay'"
                          >0元订单</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'wx_pay'"
                          >微信支付</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'ali_pay'"
                          >支付支付</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderSource"
                      label="订单来源"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.orderSource === 'wxShop'"
                          >微店订单</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderType"
                      label="订单类型"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.orderType === 'wshop'"
                          >微店订单</span
                        >
                        <span v-if="scope.row.orderType === 'ptdd'"
                          >拼团订单</span
                        >
                        <span v-if="scope.row.orderType === 'kjdd'"
                          >砍价订单</span
                        >
                        <span v-if="scope.row.orderType === 'mshd'"
                          >秒杀订单</span
                        >
                        <span v-if="scope.row.orderType === 'smg_faceToFace'"
                          >代客下单-当面收款</span
                        >
                        <span v-if="scope.row.orderType === 'smg_netPush'"
                          >代客下单-网络推送</span
                        >
                        <span v-if="scope.row.orderType === 'dhdd'"
                          >兑换订单</span
                        >
                        <span v-if="scope.row.orderType === 'integral_order'"
                          >积分兑换订单</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="mb20">
                  <el-table
                    stripe
                    border
                    :data="[detailsOrder.order]"
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="deliveryType"
                      label="配送方式"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.deliveryType === 'mdzt'"
                          >门店自提</span
                        >
                        <span v-if="scope.row.deliveryType === 'kdfh'"
                          >快递发货</span
                        >
                        <span v-if="scope.row.deliveryType === 'tcps'"
                          >同城配送</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="detailsOrder.order.deliveryType === 'mdzt'"
                      header-align="center"
                      align="center"
                      prop="billNo"
                      label="提货单号"
                    ></el-table-column>
                    <el-table-column
                      v-else
                      header-align="center"
                      align="center"
                      prop="expressOrderSn"
                      label="物流单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="自动确认收货时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopName"
                      label="指定信息"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderRemark"
                      label="订单备注"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="活动信息"
                    ></el-table-column>
                  </el-table>
                </div>
              </li>
              <li class="mb20">
                <div class="title">收货人信息</div>
                <el-table
                  stripe
                  border
                  :data="[detailsOrder.order]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverName"
                    label="收货人"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverMobile"
                    label="手机号码"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="邮政编码"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliveryAddress"
                    label="收货地址"
                  >
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">商品信息</div>
                <el-table
                  border
                  :data="detailsOrder.orderGoods"
                  size="small"
                  :row-class-name="tableRowClassNames"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsImg"
                    label="商品图片"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <div>
                        <div
                          class="flex flex-center item-center"
                          v-if="scope.row.returnType !== 'no'"
                        >
                          <!-- 仅退款 -->
                          <img
                            v-if="scope.row.refundReturnType === 'money'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                            alt=""
                          />

                          <!-- 退货退款 -->
                          <img
                            v-if="scope.row.refundReturnType === 'refund'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                            alt=""
                          />

                          <!-- 退运费 -->
                          <img
                            v-if="scope.row.refundReturnType === 'deliver'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                            alt=""
                          />
                        </div>

                        <img
                          class="warning-tuikuan"
                          v-show="scope.row.returnType === 'yes'"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                          alt=""
                        />
                        <img
                          class="warning-tuikuan"
                          v-show="scope.row.returnType === 'doing'"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                          alt=""
                        />
                        <div
                          class="flex flex-center item-center"
                          :class="
                            scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                          "
                        >
                          <img
                            style="width:100px;height:100px;"
                            v-if="scope.row.goodsImg"
                            :src="scope.row.goodsImg"
                            alt=""
                          />
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="商品名称/品牌"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        :content="scope.row.spuName"
                        placement="top"
                      >
                        <div class="flex item-center">
                          <!-- <span class="pos" v-if="scope.row.createMode">
                          p
                        </span> -->

                          <span class="time flex-1 text-overflow">
                            {{ scope.row.spuName }}
                          </span>
                        </div>
                      </el-tooltip>
                      <div>品牌: {{ scope.row.brandName }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="价格/货号"
                  >
                    <template slot-scope="scope">
                      <p>价格: {{ scope.row.totalPrice }}</p>
                      <p>货号: {{ scope.row.goodsSn }}</p>
                      <p>条码: {{ scope.row.barCode }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="净重/毛重"
                  >
                    <template slot-scope="scope">
                      <p v-if="scope.row.netWeight">
                        净重: {{ scope.row.netWeight }}
                      </p>
                      <p v-if="scope.row.grossWeight">
                        毛重: {{ scope.row.grossWeight }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="specIdGroupName"
                    label="规格"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsNum"
                    label="数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="totalPrice"
                    label="小计"
                  >
                    <template slot-scope="scope">
                      <p>
                        {{
                          (scope.row.totalPrice * scope.row.goodsNum).toFixed(2)
                        }}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">费用信息</div>
                <el-table
                  stripe
                  border
                  :data="[detailsOrder.order]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="totalPrice"
                    label="商品合计"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.totalPrice }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliverMoney"
                    label="运费"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.deliverMoney }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliverCouponMoney"
                    label="运费券抵扣"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.deliverCouponMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="packageMoney"
                    label="包装费"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.packageMoney }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="couponMoney"
                    label="优惠券"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.couponMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="积分抵扣"
                    v-if="detailsOrder.order.orderType === 'integral_order'"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.activeMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="活动优惠"
                    v-else
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.activeMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="金豆"
                    v-if="
                      detailsOrder.order.otherPayInfo &&
                        detailsOrder.order.otherPayInfo.length
                    "
                  >
                    <template slot-scope="scope">
                      <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                        <div v-if="v.financeCode === 'goldBean'">
                          金豆：已用{{ v.financeValue }}{{ v.relName }}抵用
                          <span class="danger">-￥{{ v.currencyAmount }}</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="actuallyPrice"
                    label="实付金额"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.orderType === 'integral_order'"
                        class="status danger"
                      >
                        <span v-if="scope.row.actuallyPrice"
                          >¥{{ scope.row.actuallyPrice }}+</span
                        >
                        <span>{{ scope.row.integralPoint }}积分 </span>
                      </div>
                      <span v-else class="status danger"
                        >¥{{ scope.row.actuallyPrice }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="payPrice"
                    label="应付金额"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.orderType === 'integral_order'"
                        class="status danger"
                      >
                        <span v-if="scope.row.payPrice"
                          >¥{{ scope.row.payPrice }}+</span
                        >
                        <span>{{ scope.row.integralPoint }}积分 </span>
                      </div>
                      <span v-else class="status danger"
                        >¥{{ scope.row.payPrice }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">操作信息</div>
                <el-table
                  stripe
                  border
                  :data="detailsOrder.orderStatus"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="operatorAccount"
                    label="操作账号"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="operatorName"
                    label="操作人"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.operatorName === null">
                        {{ scope.row.createBy }}
                      </div>
                      <div v-else>
                        {{ scope.row.operatorName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="createTime"
                    label="操作时间"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="订单状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >待付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >待发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已收货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已评价</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'returnOrder'"
                        >有退货退款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'rejectOrder'"
                        >驳回申请</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="付款状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >未付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="发货状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >未发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >未发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="remark"
                    label="备注"
                  ></el-table-column>
                  <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button size="small" type="text" @click="beizhu(scope.row)"
                        >添加备注</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
                </el-table>
              </li>
            </div>
          </ul>
          <ul class="info-list flex-1" style="width:50%">
            <div style="padding:0 10px">
              <li>
                <div class="progress mb20" v-if="delOrder">
                  <el-steps :active="active" align-center>
                    <el-step
                      title="发起申请"
                      :description="returnSendTime"
                    ></el-step>
                    <el-step
                      title="核定信息"
                      :description="returnConfirmTime"
                    ></el-step>
                    <el-step
                      v-if="returnInfo.status !== 8"
                      title="退货/退款"
                      :description="refundTime"
                    ></el-step>
                    <el-step
                      title="驳回"
                      v-if="returnInfo.status == 8"
                    ></el-step>
                  </el-steps>
                  <!-- <el-steps :active="active" align-center>
                  <el-step title="创建订单" :description="createOrderTime"></el-step>
                  <el-step title="支付订单" :description="payOrderTime"></el-step>
                  <el-step
                    title="平台配货发货"
                    :description="deliverOrderTime"
                  ></el-step>
                  <el-step title="确认收货" :description="takeOrderTime"></el-step>
                  <el-step title="完成评价" :description="pushOrderTime"></el-step>
                </el-steps> -->
                </div>
              </li>
              <li class="mb20">
                <div class="title">
                  <div class="expressSn flex flex-column">
                    <div v-for="(v, i) in returnGoods" :key="i">
                      <div v-if="v.expressSn">
                        退货快递单号：{{v.expressSn}} <span @click="orderDetail(v)">查看物流》</span>
                      </div>
                    </div>
                  </div>
                  退款单
                </div>

                <div
                  v-if="(mopDirectlyCancelLog && typeof mopDirectlyCancelLog === 'object') || mopRefundOrderWriteConfig"
                  class="mop-cancel-tips"
                  :class="mopDirectlyCancelLog && mopDirectlyCancelLog.mopWriteState === 'success' ? 'mop-cancel-success' : 'mop-cancel-fail'"
                >
                  <template v-if="mopDirectlyCancelLog && typeof mopDirectlyCancelLog === 'object'">
                    <template v-if="mopDirectlyCancelLog.mopWriteState === 'success'">
                      整单退单到MOP 写入成功 mop退单号：<span class="mop-refund-no">{{ mopDirectlyCancelLog.mopRefundNo }}</span>
                    </template>
                    <template v-else>
                      <span>整单退单到MOP <span class="mop-fail-text">写入失败：{{ mopDirectlyCancelLog.mopWriteResult }}</span> </span>
                      <el-button
                        type="danger"
                        size="mini"
                        class="mop-retry-btn"
                        @click="retryMopDirectlyCancel"
                      >重新写入</el-button>
                    </template>
                  </template>
                  <template v-else-if="mopRefundOrderWriteConfig">
                    {{ mopRefundOrderWriteConfig.configClass[mopRefundOrderWriteConfig.paramValue] || '' }}
                  </template>
                </div>

                <div class="mb20 flex-1">
                  <el-table
                    border
                    :data="returnGoods"
                    :span-method="objectSpanMethod"
                    size="small"
                    @row-click="openDetails"
                    highlight-current-row
                    :row-class-name="tableRowClassName"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnSn"
                      label="退货单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="商品名称"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          :content="scope.row.spuName"
                          placement="top"
                        >
                          <div class="flex item-center">
                            <!-- <span class="pos" v-if="scope.row.createMode">
                            p
                          </span> -->
                            <span class="time flex-1 text-overflow">
                              {{ scope.row.spuName }}
                            </span>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnSendTime"
                      label="退单时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="status"
                      label="退款状态"
                    >
                      <template slot-scope="scope">
                        <span class="danger" v-if="scope.row.status === 1"
                          >待审核</span
                        >
                        <span class="danger" v-if="scope.row.status === 2"
                          >已审核</span
                        >
                        <span class="danger" v-if="scope.row.status === 3"
                          >已退货待退款</span
                        >
                        <span class="blue" v-if="scope.row.status === 4"
                          >已退款</span
                        >
                        <span class="gray" v-if="scope.row.status === 5"
                          >待确认</span
                        >
                        <span class="danger" v-if="scope.row.status === 8"
                          >已驳回</span
                        >
                        <span class="gray" v-if="scope.row.status === 9"
                          >已取消</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnAmount"
                      label="退商品"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnAmount }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnAmount"
                      label="商品核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnAmount',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnAmount"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnAmount }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnDeliverMoney"
                      label="退运费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnDeliverMoney }}</span
                        >
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnDeliverMoney"
                      label="运费核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnDeliverMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnDeliverMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnDeliverMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPackageMoney"
                      label="退包装费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPackageMoney }}</span
                        >
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnPackageMoney"
                      label="包装费核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnPackageMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnPackageMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnPackageMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="prepayMoney"
                      label="退储值卡"
                      v-if="!queryConfigFlag"
                    >
                      <template slot-scope="scope">
                        <span class="danger">¥{{ scope.row.prepayMoney }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPrepayCardMoney"
                      label="退储值卡"
                      v-if="queryConfigFlag"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPrepayCardMoney }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnPrepayCardMoney"
                      label="核定退储值卡"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnPrepayCardMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnPrepayCardMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnPrepayCardMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnIntegral"
                      label="退积分"
                      v-if="isShowReturnIntegral"
                    >
                      <template slot-scope="scope">
                        <span class="danger">{{
                          scope.row.returnIntegral
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="核定退积分"
                      v-if="isShowReturnIntegral"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <div v-if="active < 2">
                          <el-input
                            v-if="scope.row.confirmReturnIntegral"
                            clearable
                            type="txt"
                            @mousewheel.prevent.native
                            @input="
                              filterGt0OrFixed2(
                                'confirmReturnIntegral',
                                scope.$index
                              )
                            "
                            style="width:100%;"
                            v-model.trim="scope.row.confirmReturnIntegral"
                            size="small"
                          ></el-input>
                          <div v-else>
                            <span class="danger"
                              >¥{{ scope.row.confirmReturnIntegral }}</span
                            >
                          </div>
                        </div>
                        <div v-else class="danger">
                          {{ scope.row.confirmReturnIntegral }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="activeTab == 0"
                      header-align="center"
                      align="center"
                      prop="mopRefundNo"
                      label="退款单号"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.mopRefundNo }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="activeTab == 0"
                      label="操作"
                      header-align="center"
                      align="center"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 1 && isBtn('tongyi:false')"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="consent(scope.$index)"
                            >同意退款</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            v-if="refundAgain !== 'yes'"
                            @click="bohui(scope.$index)"
                            >驳回</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            class="blue"
                            v-if="returnType==='deliver' && scope.row.returnAmount==0"
                            @click="applyReturnGoods(scope.row,scope.$index)"
                            >申请退商品</el-button
                          >
                        </div>
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 2 && isBtn('queren:false')"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="consent(scope.$index)"
                            >确认退款</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            @click="bohui(scope.$index)"
                            >驳回</el-button
                          >
                        </div>
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 4"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="jixu(scope.$index)"
                            >继续退款</el-button
                          >
                        </div>
                        <div v-if="scope.row.status === 5">
                          <el-button
                            size="small"
                            type="text"
                            @click="undo(scope.row)"
                            >撤销</el-button
                          >
                          <el-button
                              size="small"
                              type="text"
                              @click="makeSenseDialog(scope.row)"
                              v-if="isBtn('makeSense:false')"
                          >代确认退款</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="mb20">
                  <div class="title">操作记录</div>
                  <el-table stripe border :data="refundRecordList" size="small">
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="receiverName"
                      label="操作状态"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.operationType === 'apply'"
                          >申请退款</span
                        >
                        <span v-else-if="scope.row.operationType === 'agree'"
                          >同意退款</span
                        >
                        <span v-else-if="scope.row.operationType === 'refuse'"
                          >驳回申请</span
                        >
                        <span v-else-if="scope.row.operationType === 'pay'"
                          >确认退款</span
                        >
                        <span
                          v-else-if="scope.row.operationType === 'backApply'"
                          >后台发起</span
                        >
                        <span
                          v-else-if="scope.row.operationType === 'agreeAgain'"
                          >再次同意</span
                        >
                        <span v-else-if="scope.row.operationType === 'payAgain'"
                          >再次确认</span
                        >
                        <span v-else-if="scope.row.operationType === 'applyReturnGoods'"
                          >申请退商品</span
                        >
                        <span v-else-if="scope.row.operationType === 'makeSense'"
                        >代确认退款</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnAmount"
                      label="金额/积分"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnAmount }} /
                          {{ scope.row.returnIntegral || 0 }}积分</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnDeliverMoney"
                      label="运费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnDeliverMoney }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPackageMoney"
                      label="包装费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPackageMoney }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPrepayCardMoney"
                      label="储值卡"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationRemark"
                      label="操作备注"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationTime"
                      label="操作时间"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationName"
                      label="操作人"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span>
      <!-- <span
        slot="footer"
        class="dialog-footer flex flex-center"
        v-if="!disabled"
      >
        <el-button
          @click="consent"
          size="small"
          type="primary"
          v-if="returnType === 'money' && status == 1"
        >
          同意退款</el-button
        >
        <el-button
          @click="consent"
          size="small"
          type="primary"
          v-if="returnType === 'money' && status == 2"
        >
          确认退款</el-button
        >
        <el-button
          @click="consent"
          size="small"
          type="primary"
          v-if="returnType === 'refund' && status == 1"
        >
          同意退货</el-button
        >
        <el-button
          @click="consent"
          size="small"
          type="primary"
          v-if="returnType === 'refund' && status == 2"
        >
          确认退货</el-button
        >
        <el-button
          @click="consent"
          size="small"
          type="primary"
          v-if="returnType === 'refund' && status == 3"
        >
          确认退款</el-button
        >

        <el-button @click="reject" size="small" type="primary">驳回</el-button>
      </span> -->
    </el-dialog>
    <el-dialog
      title="操作备注"
      :visible.sync="detailsVisible"
      @close="detailsVisible = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="操作备注" prop="operationRemark">
          <div class="flex">
            <el-input
              maxlength="100"
              placeholder="请输入操作备注"
              size="small"
              style="width: auto"
              ref="textarea"
              :autosize="{ minRows: 4 }"
              type="textarea"
              v-model="ruleForm.operationRemark"
            ></el-input>
            <div class="from-tips ml20" v-if="returnReason && returnReason.list && returnReason.list.length">
              <div>检查到当前单据在OMS系统中的售后工单</div>
              <div v-for="(v,i) in returnReason.list" :key="i">
                <div>id:{{v.id}}</div>
                <div>sid:{{v.sid}}</div>
                <div>状态为:<span class="red">"{{ v.statusLabel }}"</span></div>
              </div>
              <div class="mt20">
                请确认货品状态，避免造成货品和财产损失.<br>
                如果货品状态为确认，请点击关闭按钮，停止当前操作!
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          id="btn"
          @click="reject('ruleForm')"
          size="small"
          type="primary"
          >确认</el-button
        >
        <el-button @click="detailsVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
    :visible.sync="returnNumberVisible"
    >
      <div slot="title">
        <span class="mr10" >退款数量</span>
      </div>
      <el-form
        class="mt20"
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="退款数量" prop="returnNumber">
          <div class="flex">
            <el-input
              maxlength="100"
              placeholder="请输入退款数量"
              size="small"
              style="width: auto"
              :autosize="{ minRows: 4 }"
              type="number"
              @input="handleInput"
              v-model="ruleForm.returnNumber"
            ></el-input>
            </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button id="btn" size="small" type="primary" @click="makeSureNumber(currnetIndex)"
          >确认</el-button
        >
        <el-button @click="returnNumberVisible = false" size="small"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <!-- 储值卡已被使用过提示 -->
    <el-dialog
      :visible.sync="prepayCardUsedVisible"
      @close="prepayCardUsedVisible = false"
      custom-class="sales-volumn-dialog"
      width="1200px"
    >
      <span slot="title">
        <div class="orange" style="font-size:18px;font-weight:bold">
          {{ prepayCardUsedErrmag }}
        </div>
      </span>
      <el-table stripe border :data="memberRelModelList" size="small" :key="Math.random()">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardName"
          label="储值卡名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="持卡人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="持卡人卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="持卡人电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStatus"
          label="卡状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.level === 1">--</div>
            <div v-else>
              <div v-if="scope.row.cardStatus === 'frozen'" class="danger">
                冻结
              </div>
              <div v-if="scope.row.cardStatus === 'lock'" class="blue">
                锁定
              </div>
              <div v-if="scope.row.cardStatus === 'ok'" class="success">
                正常
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceType"
          label="获得方式"
        >
          <template slot-scope="scope">
            {{ scope.row.sourceType === "buy" ? "购买" : "赠送" }}
            <div v-if="scope.row.sourceType === 'give'">
              <el-button type="text" size="small" @click="giveInfo(scope.row)">
                赠送来源
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceReceiptSn"
          label="购卡订单号"
        >
          <template slot-scope="scope">
            {{ scope.row.sourceReceiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardSalePrice"
          label="储值卡售价"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardSalePrice }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardDenomination"
          label="储值卡面额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardDenomination }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardBalance"
          label="储值卡余额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardBalance }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStartTime"
          label="购买时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardsTime"
          label="储值卡有效期"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.cardStartTime }}至{{ scope.row.cardEndTime }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button id="btn" size="small" type="primary" @click="doubleReject"
          >确认退款</el-button
        >
        <el-button @click="prepayCardUsedVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <!--发送退货地址-->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="returnAddressVisible"
    >
      <div slot="title">
        <span class="mr10" v-if="status===2">发送退货地址</span>
        <span class="mr10" v-else>操作备注</span>
      </div>
      <el-button type="primary" size="small" @click="storeAddressAdd" v-if="status===2">新增</el-button>
      <el-table stripe border :data="storeAddressInfoList" size="small" :key="Math.random()" class="mt10" v-if="status===2">
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          label="单选"
        >
          <template slot-scope="scope">
            <el-radio v-model="selectRadio" :label="scope.row.id" @change="changeSelectRadio(scope.row)"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverName"
          label="收货人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverMobile"
          label="收货人手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverAddress"
          label="收货人地址"
        >
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <div class="pointer mr10 danger" @click="storeAddressRemoves(scope.row)">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
        <el-form
        class="mt20"
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="操作备注" prop="operationRemark">
          <div class="flex">
          <el-input
            maxlength="100"
            placeholder="请输入操作备注"
            size="small"
            style="width: auto"
            ref="textarea"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.operationRemark"
          ></el-input>
          <div class="from-tips ml20" v-if="returnReason && returnReason.list && returnReason.list.length">
            <div>检查到当前单据在OMS系统中的售后工单</div>
            <div v-for="(v,i) in returnReason.list" :key="i">
              <div>id:{{v.id}}</div>
              <div>sid:{{v.sid}}</div>
              <div>状态为:<span class="red">"{{ v.statusLabel }}"</span></div>
            </div>
            <div class="mt20">
              请确认货品状态，避免造成货品和财产损失.<br>
              如果货品状态为确认，请点击关闭按钮，停止当前操作!
            </div>
          </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button id="btn" size="small" type="primary" @click="reject('ruleForm')"
          >确认</el-button
        >
        <el-button @click="returnAddressVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="returnAddressAddVisible"
    >
      <div slot="title">
        <span class="mr10">新增退货地址</span>
      </div>
      <div class="text-left">
          <el-form
            :model="receiverList"
            ref="receiverList"
            label-width="120px"
            :rules="rulesReceiver"
          >
            <el-form-item label="收货人姓名" prop="receiverName">
              <el-input
                clearable
                maxlength="5"
                @mousewheel.prevent.native
                v-model.trim="receiverList.receiverName"
                placeholder="请输入收货人姓名"
                size="small"
                class="ipt mr10"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人手机号" prop="receiverMobile">
              <el-input
                clearable
                maxlength="11"
                @mousewheel.prevent.native
                v-model.trim="receiverList.receiverMobile"
                placeholder="请输入收货人手机号"
                size="small"
                class="ipt mr10"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人地址" prop="receiverAddress">
              <el-input
                clearable
                @mousewheel.prevent.native
                v-model.trim="receiverList.receiverAddress"
                placeholder="请输入收货人地址"
                size="small"
                class="ipt mr10"
              ></el-input>
            </el-form-item>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button id="btn" size="small" type="primary" @click="storeAddressInfoAdd('receiverList')"
          >提交</el-button
        >
        <el-button @click="returnAddressAddVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <!--物流快递-->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="logisticsInfoVisible"
    >
      <div slot="title">
        <span class="mr10">物流快递</span>
      </div>
      <ul class="logistics-list">
        <li>
          <div class="title">物流信息:</div>
          <div class="text">退货快递单号:{{expressSn}}</div>
          <div class="text">退货快递手机号:{{expressSenderPhone}}</div>
          <div class="text" v-if="expressInfoResult.company_name">物流快递:{{expressInfoResult.company_name}}</div>
          <div>
            <!-- <el-steps direction="vertical" :active="1">
              <el-step title="已签收" icon="el-icon-edit"></el-step>
               <el-step
                :title="v.AcceptTime"
                :description="v.AcceptStation"
                v-for="(v, i) in showLogsistics.courierInfo.traces"
                :key="i"
              ></el-step>
              <el-step title="已揽件" description="包裹正在等待揽收"></el-step>
              <el-step title="已下单" ></el-step>

            </el-steps> -->

            <div class="div-bg bg-white" style="background:#f7f7f7">
              <div
                style="height: 0.5rem;width: 100%;backgroundColor:#f7f7f7"
              ></div>
              <!--物流跟踪-->
              <div style="paddingBottom: 0.5rem;">
                <div
                  class="bg-white"
                  style="width: 92%; marginLeft: 4%;margin: auto;paddingLeft: 15px;paddingRight: 15px;"
                >
                  <div>
                    <div class="track-rcol">
                      <div class="track-list">
                        <el-scrollbar
                          :vertical="false"
                          wrap-style="max-height: 400px;"
                        >
                          <ul>
                            <div
                              v-for="(item, index) in expressInfoResult.traces"
                              :key="index"
                            >
                              <li :class="index === 0 ? 'first' : ''">
                                <div></div>
                                <i class="node-icon"></i>
                                <span class="txt">{{
                                  item.AcceptStation
                                }}</span>
                                <span class="time">{{ item.AcceptTime }}</span>
                              </li>
                            </div>
                          </ul>
                        </el-scrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="logisticsInfoVisible = false"
          size="small"
          type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="代确认退款"
        :visible.sync="makeSenseVisible"
        @close="makeSenseVisible = false"
        custom-class="sales-volumn-dialog"
    >
      <div class="title">代替用户确认退款之前需跟客户沟通，以免引起投诉</div>
      <el-form
          label-width="80px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
      >
        <el-form-item label="操作备注" prop="operationRemark" style="padding-top: 30px">
          <el-input
              maxlength="100"
              placeholder="请输入操作备注"
              size="small"
              style="width: auto"
              ref="textarea"
              :autosize="{ minRows: 4 }"
              type="textarea"
              v-model="ruleForm.operationRemark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
            id="btn"
            @click="makeSense(row)"
            size="small"
            type="primary"
        >确认</el-button
        >
        <el-button @click="makeSenseVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie, formatFloat } from "@/utils/utils";
import { getLoginUser } from "@/utils/auth";
import moment from "moment";
export default {
  mixins: [outPutMixin],
  data() {
    return {
      storeCode: "",
      dkShops: [],
      activeTab:0,
      prepayCardUsedErrmag: "",
      memberRelModelList: [],
      prepayCardUsedVisible: false,
      ruleForm: {
        operationRemark: "",
        returnNumber:'0'
      },
      rules: {
        // operationRemark: {
        //   required: true,
        //   message: "请输入操作备注",
        //   trigger: "change"
        // }
      },
      detailsVisible: false,
      dialogVisible: false,
      logisticsInfoVisible: false,
      makeSenseVisible: false,
      disabled: false,
      show: false,
      checkedRow: {},
      batchCondition: {},
      searchCondition: {
        queryTimeType: "returnSendTime",
        status: "1",
        applyDate: [
          moment().format("YYYY-MM-DD") + " 00:00:00",
          moment().format("YYYY-MM-DD") + " 23:59:59"
        ],
      },
      currentPage: 1,
      pageSize: 10,
      active: 0,
      title: "",
      returnSendTime: "",
      refundTime: "",
      returnConfirmTime: "",
      delOrder: true,
      innerVisible: false,
      isOutputing: false,
      orderGoodsId: "",
      totalPrice: "",
      orderRefundId: "",
      status: "",
      returnType: "",
      receiptSn: "",
      orderSta: "",
      createOrderTime: "",
      payOrderTime: "",
      deliverOrderTime: "",
      takeOrderTime: "",
      pushOrderTime: "",
      returnGoods: [],
      returnSn: "",
      refundRecordList: [],
      confirmReturnAmount: "",
      confirmReturnDeliverMoney: "",
      confirmReturnPrepayCardMoney: "",
      returnInfo: {},
      mopDirectlyCancelLog: null,
      mopRefundOrderWriteConfig: null,
      mopRefundLogList: [],
      orderId: "",
      queryConfigFlag: false,
      position: 0,
      rowSpanArr: [],
      isShowReturnIntegral: false,
      returnIntegral: 0,
      confirmReturnIntegral: 0,
      refundAgain: "",
      expressSn: "",
      expressSenderPhone: "",
      returnTranslate: "",
      showLogsistics: {
        order: {},
        courierInfo: {
          traces: []
        }
      },
      expressInfoResult:{
        company_name:"",
        traces: [],
      },
      selectRadio: "",
      selectRadioRow:{},
      row: "",
      returnAddressVisible: false,
      returnNumberVisible:false,
      currnetIndex:0,
      returnNumber:'0',
      returnAddressAddVisible: false,
      storeAddressInfoList:[],
      receiverList:{
        receiverName: "",
        receiverMobile: "",
        receiverAddress: "",
        enabledState: "yes"
      },
      rulesReceiver:{
        receiverName: {
          required: true,
          message: "请输入收货人姓名",
          trigger: "blur"
        },
        receiverMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        },
        receiverAddress: {
          required: true,
          message: "请输入收货人地址",
          trigger: "blur"
        },
      },
      nowRow:"",
      returnReason: {},
      statusList:[
        {
          label: "未解决",
          value: 2,
        },
        {
          label: "已解决",
          value: 9,
        },
        {
          label: "已作废",
          value: 10,
        },
        {
          label: "已合并",
          value: 11,
        },
        {
          label: "解决中",
          value: 12,
        }
      ],
    };
  },
  created() {
    this.getParamsCookie();
    if (this.$route.query.type) {
      this.searchCondition.status = this.$route.query.type;
    }
    this.queryList();
    this.queryConfigRefundAmount();
  },
  computed: mapGetters([
    "orderReturnList",
    "detailsorderReturn",
    "salesChannels",
    "allMallGoodsList",
    "shopModelList",
    "microShopStoreList",
    "detailsOrder",
    "dkMicroShopStoreList"
  ]),
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      let res = this.$store.dispatch("queryDkMicroStoreList");
      if (res) {
        res.then((r) => {
          if (r.result) {
            r.result.filter(v=>{
              if (v.shopId != "直营店" && v.shopId != "加盟店" ) {
                this.dkShops.push(v);
              }
            })
          }
        });
      }
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
  },
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = "合计";
    //       return;
    //     }
    //     const values = data.map(item => Number(item[column.property]));
    //     if (!values.every(value => isNaN(value))) {
    //       sums[index] = values.reduce((prev, curr) => {
    //         const value = Number(curr);
    //         if (!isNaN(value)) {
    //           return prev + curr;
    //         } else {
    //           return prev;
    //         }
    //       }, 0);
    //       sums[index] += " 元";
    //     } else {
    //       sums[index] = "";
    //     }
    //   });

    //   return sums;
    // },
    async removes() {
      const confirm = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (confirm === "confirm") {
        console.log("a: ", 12312312);
      }
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.returnGoods.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.returnGoods[index].prepayMoney ==
            this.returnGoods[index - 1].prepayMoney
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.returnGoods[index].prepayMoney = this.returnGoods[
              index - 1
            ].prepayMoney;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置
      if (!this.queryConfigFlag) {
        if (columnIndex === 10) {
          const _row = this.rowSpanArr[rowIndex];

          return {
            rowspan: _row, //行
            colspan: 1 //列
          };
        }
      }
    },
    async queryConfigRefundAmount() {
      const { result } = await this.$store.dispatch("queryConfigRefundAmount", {
        code: "refundAmountLimit"
      });
      if (result) {
        this.queryConfigFlag = result.value === "0" ? true : false;
      } else {
        this.queryConfigFlag = true;
      }
    },
    isBtn(code) {
      console.log("this.code::::", code);
      console.log(this.isShowBtn(code))
      return this.isShowBtn(code);
    },
    filterGt0OrFixed2(prop, index) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.returnGoods[index][prop] = this.returnGoods[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.returnGoods[index][prop].indexOf(".") < 0 &&
        this.returnGoods[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.returnGoods[index][prop] = parseFloat(
          this.returnGoods[index][prop]
        );
      }
    },
    switchTabs() {
      this.currentPage = 1;
      this.pageSize = 10;
      console.log("active===>",this.activeTab);
      this.queryList();
    },
    submitsearchCondition() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.wxshopCategoryId =
        batchCondition.wxshopCategoryId[
          batchCondition.wxshopCategoryId.length - 1
        ];
      batchCondition.spuIdList = this.checkedRow;
      // this.$store.dispatch("batchEdit", batchCondition).then(res => {
      //   if (res.code === "0") {
      //     this.$message({
      //       message: "操作成功",
      //       type: "success"
      //     });
      //     this.queryList();
      //     this.dialogVisible = false;
      //   }
      // });
    },
    addGoods() {
      this.$router.push({ name: "AddMicroShopGoods" });
    },
    openDetails(row) {
      this.orderGoodsId = row.orderGoodsId;
      this.returnSn = row.returnSn;
      this.receiptSn = row.receiptSn;
      this.orderRefundId = row.orderRefundId;
      this.queryOrderRefundRecord();
    },
    async queryReturnGoods() {
      let params = {
        receiptSn: this.receiptSn
      };

      const { result } = await this.$store.dispatch(
        "queryReturnGoodsList",
        params
      );
      this.returnGoods = result;
      this.returnGoods.forEach(v => {
        v.prepayMoney = this.detailsOrder.order.prepayMoney;
      });
      this.isShowReturnIntegral =
        this.returnGoods.findIndex(v => v.returnIntegral) > -1;
      this.getRowSpan();
      this.matchMopRefundNo();
    },
    matchMopRefundNo() {
      if (!this.mopRefundLogList || !this.mopRefundLogList.length) return;
      if (!this.returnGoods || !this.returnGoods.length) return;
      const refundNoMap = {};
      this.mopRefundLogList.forEach(item => {
        if (item && item.barCode) {
          refundNoMap[item.barCode] = item.mopRefundNo;
        }
      });
      this.returnGoods.forEach(v => {
        this.$set(v, "mopRefundNo", (v.barCode && refundNoMap[v.barCode]) || "");
      });
    },
    async queryOrderRefundRecord() {
      this.returnReason = {};
      let params = {
        orderRefundId: this.orderRefundId
      };
      const { result } = await this.$store.dispatch(
        "queryOrderRefundRecordList",
        params
      );
      const {mopDirectlyCancelLog, refundRecordModelList, returnInfo, mopRefundLogList } = result;
      this.refundRecordList = refundRecordModelList;
      this.returnInfo = returnInfo;
      this.mopRefundLogList = mopRefundLogList || [];
      this.matchMopRefundNo();
      this.mopDirectlyCancelLog = (mopDirectlyCancelLog && mopDirectlyCancelLog.mopWriteState) ? mopDirectlyCancelLog : null;
      this.mopRefundOrderWriteConfig = null;
      if (!this.mopDirectlyCancelLog) {
        const configRes = await this.$store.dispatch("getModelByParamCode", {
          paramCode: "mop_refund_order_write"
        });
        const configResult = configRes && configRes.result;
        if (configResult && configResult.paramValue && configResult.configClass) {
          try {
            this.mopRefundOrderWriteConfig = {
              paramValue: configResult.paramValue,
              configClass: JSON.parse(configResult.configClass)
            };
          } catch (e) {
            this.mopRefundOrderWriteConfig = null;
          }
        }
      }
      if (returnInfo.status === 1) {
        this.active = 1;
        this.disabled = false;
        this.show = false;
        this.refundTime = "";
        this.returnSendTime = returnInfo.returnSendTime;
        // this.orderSta = "发起申请";
      } else if (returnInfo.status === 2) {
        this.active = 2;
        this.disabled = false;
        this.show = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = "";
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        // this.orderSta = "核定信息";
      } else if (returnInfo.status === 3) {
        this.active = 3;
        this.show = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 4) {
        this.active = 3;
        this.disabled = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 8) {
        this.active = 3;
        this.disabled = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
      }
      if(this.returnInfo.returnReason){
        try {
          this.returnReason = JSON.parse(this.returnInfo.returnReason);
        } catch (e) {
          this.returnReason = {};
        }
        if(this.returnReason && this.returnReason.list && this.returnReason.list.length){
          this.returnReason.list.forEach(v=>{
            this.statusList.forEach(o=>{
              if(v.status === o.value){
                v.statusLabel = o.label;
              }
            })
          })
          this.returnReason.list = JSON.parse(JSON.stringify(this.returnReason.list));
        }
        console.log("this.returnReason:",this.returnReason);
      }
    },
    async retryMopDirectlyCancel() {
      if (!this.mopDirectlyCancelLog) return;
      const { storeCode } = getLoginUser();
      const params = {
        storeCode,
        hemiaoOrderSnList: [this.mopDirectlyCancelLog.receiptSn]
      };
      await this.$store.dispatch("getRefundCancelRetry", params);
      this.queryOrderRefundRecord();
    },
    detailOrder() {
      return this.$store
        .dispatch("detailOrder", {
          orderId: this.orderId
        })
        .then(res => {
          let orderSta =
            res.result.orderStatus[res.result.orderStatus.length - 1];
          let flag = false;
          res.result.orderGoods.map(v => {
            if (v.returnType === "no") {
              flag = true;
            }
          });

          if (flag) {
            let listStatus = [];
            res.result.orderStatus.forEach(v => {
              if (v.orderStatus !== "returnOrder") {
                listStatus.push(v);
              }
            });
            orderSta = listStatus[listStatus.length - 1];
          }
          if (orderSta.orderStatus === "createOrder") {
            // this.active = 1;
            // this.delOrder = true;
            // this.disabled = true;
            // this.delivery = true;
            this.orderSta = "待付款";
          } else if (orderSta.orderStatus === "payOrder") {
            // this.active = 2;
            // this.delOrder = true;
            // this.disabled = false;
            // this.delivery = true;
            this.orderSta = "待发货";
          } else if (orderSta.orderStatus === "deliverOrder") {
            // this.active = 3;
            // this.delOrder = true;
            // this.delivery = false;
            // this.disabled = true;
            this.orderSta = "已发货";
          } else if (orderSta.orderStatus === "takeOrder") {
            // this.active = 4;
            // this.delOrder = true;
            // this.delivery = true;
            // this.disabled = true;
            this.orderSta = "已收货";
          } else if (orderSta.orderStatus === "pushOrder") {
            // this.active = 5;
            // this.delOrder = true;
            // this.delivery = true;
            // this.disabled = true;
            this.orderSta = "已评价";
          } else if (orderSta.orderStatus === "delOrder") {
            // this.delOrder = false;
            this.orderSta = "已取消";
          } else if (orderSta.orderStatus === "returnOrder") {
            // this.delOrder = false;
            this.orderSta = "有退货退款";
          }

          res.result.orderStatus.forEach(v => {
            if (v.orderStatus === "createOrder") {
              this.createOrderTime = v.createTime;
            }
            if (v.orderStatus === "payOrder") {
              this.payOrderTime = v.createTime;
            }
            if (v.orderStatus === "deliverOrder") {
              this.deliverOrderTime = v.createTime;
            }
            if (v.orderStatus === "takeOrder") {
              this.takeOrderTime = v.createTime;
            }
            if (v.orderStatus === "pushOrder") {
              this.pushOrderTime = v.createTime;
            }
          });
          this.queryReturnGoods();
        });
    },
    toDetails(row) {
      this.nowRow = row;
      this.receiptSn = row.receiptSn;
      this.returnSn = row.returnSn;
      this.orderRefundId = row.orderRefundId;
      this.returnType = row.returnType;
      this.dialogVisible = true;
      this.orderGoodsId = row.orderGoodsId;
      this.orderId = row.orderId;

      this.queryOrderRefundRecord();
      this.detailOrder();
      // this.queryReturnGoods();
      // this.$store
      //   .dispatch("detailsOrderReturn", {
      //     orderRefundId: row.orderRefundId,
      //     receiptSn: row.receiptSn
      //   })
      //   .then(res => {
      //     let orderSta = res.result.returnOrder;
      //     if (orderSta.status === 1) {
      //       this.active = 1;
      //       this.disabled = false;
      //       this.show = false;
      //       this.refundTime = "";
      //       this.returnSendTime = orderSta.returnSendTime;
      //       this.orderSta = "发起申请";
      //     } else if (orderSta.status === 2) {
      //       this.active = 2;
      //       this.disabled = false;
      //       this.show = true;
      //       this.returnSendTime = orderSta.returnSendTime;
      //       this.refundTime = "";
      //       this.returnConfirmTime = orderSta.returnConfirmTime;
      //       this.orderSta = "核定信息";
      //     } else if (orderSta.status === 3) {
      //       this.active = 3;
      //       this.show = true;
      //       this.returnConfirmTime = orderSta.returnConfirmTime;
      //       this.returnSendTime = orderSta.returnSendTime;
      //       this.refundTime = orderSta.refundTime;
      //       this.orderSta = "退货/退款";
      //     } else if (orderSta.status === 4) {
      //       this.active = 3;
      //       this.disabled = true;
      //       this.returnConfirmTime = orderSta.returnConfirmTime;
      //       this.returnSendTime = orderSta.returnSendTime;
      //       this.refundTime = orderSta.refundTime;
      //       this.orderSta = "退货/退款";
      //     } else if (orderSta.status === 8) {
      //       this.active = 3;
      //       this.disabled = true;
      //       this.returnSendTime = orderSta.returnSendTime;
      //       this.returnConfirmTime = orderSta.returnConfirmTime;
      //     }

      //     this.status = orderSta.status;

      //     this.orderGoodsId = orderSta.orderGoodsId;
      //     //   res.result.orderStatus.forEach(v => {
      //     //     if (v.orderStatus === "createOrder") {
      //     //       this.createOrderTime = v.createTime;
      //     //     }
      //     //     if (v.orderStatus === "payOrder") {
      //     //       this.payOrderTime = v.createTime;
      //     //     }
      //     //     if (v.orderStatus === "deliverOrder") {
      //     //       this.deliverOrderTime = v.createTime;
      //     //     }
      //     //     if (v.orderStatus === "takeOrder") {
      //     //       this.takeOrderTime = v.createTime;
      //     //     }
      //     //     if (v.orderStatus === "pushOrder") {
      //     //       this.pushOrderTime = v.createTime;
      //     //     }
      //     //   });
      //   });
    },
    close() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.refundAgain = "";
      this.createOrderTime = "";
      this.payOrderTime = "";
      this.deliverOrderTime = "";
      this.takeOrderTime = "";
      this.pushOrderTime = "";
      this.belongShopId = "";
      this.ruleForm.cancelMsg = "";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList("queryAll")
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              v.haha = "售后申请";
              if (v.returnType == "money") {
                v.returnType = "仅退款";
              } else if (v.returnType == "refund") {
                v.returnType = "退货退款";
              } else if (v.returnType == "deliver") {
                v.returnType = "退运费";
              }
              if (v.status == "1") {
                v.status = "已提交";
              } else if (v.status == "2") {
                v.status = "已审核";
              } else if (v.status == "3") {
                v.status = "已退货待退款";
              } else if (v.status == "4") {
                v.status = "已退款";
              } else if (v.status == "8") {
                v.status = "已驳回";
              } else if (v.status == "9") {
                v.status = "已取消";
              }
            });

            const tHeader = [
              "退款编码",
              "退款方式",
              "订单编号",
              "订单生成时间",
              "会员姓名",
              "会员手机",
              "商品名称",
              "商品编码",
              "商品条码",
              "申请退款金额",
              "核定退款金额",
              "申请时间",
              "退款申请人",
              "运费退款申请",
              "运费退款核定",
              "退款时间",
              "退款人",
              "退款状态",
              "退款类型",
              "所属门店"
            ];
            const filterVal = [
              "returnSn",
              "returnType",
              "receiptSn",
              "orderCreateTime",
              "memberName",
              "memberMobile",
              "spuName",
              "goodsSn",
              "barCode",
              "returnAmount",
              "confirmReturnAmount",
              "returnSendTime",
              "operationName",
              "returnDeliverMoney",
              "confirmReturnDeliverMoney",
              "refundTime",
              "refundOperator",
              "status",
              "haha",
              "shopName"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "售后订单" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    tableRowClassName({ row }) {
      if (row.returnSn === this.returnSn) {
        return "tuikuan";
      }
      return "";
    },
    tableRowClassNames({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    async doubleReject() {
      let params = {
        orderRefundId: this.orderRefundId,
        confirmReturnAmount: this.confirmReturnAmount,
        confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
        confirmReturnPackageMoney: this.confirmReturnPackageMoney,
        confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
        returnIntegral: this.returnIntegral,
        confirmReturnIntegral: this.confirmReturnIntegral,
        status: this.status,
        receiptSn: this.receiptSn,
        orderGoodsId: this.orderGoodsId,
        centerId: this.detailsOrder.order.centerId,
        isConfirm: "yes"
      };
      Object.assign(params, this.ruleForm);
      const { code, result, inMsg, errMsg } = await this.$store.dispatch(
        "orderReturnUpd",
        params
      );

      if (code === "0") {
        this.detailsVisible = false;
        this.prepayCardUsedVisible = false;
        if (result === "error") {
          this.$message({
            message: "该商品已经核定售后金额",
            type: "warning"
          });
        } else if (inMsg === "prepayCardUsed") {
          //储值卡已被使用过
          this.prepayCardUsedVisible = true;
          this.prepayCardUsedErrmag = errMsg;
          this.memberRelModelList = result.memberRelModelList;
          setTimeout(() => {
            this.$message({
              message: errMsg,
              type: "warning"
            });
          }, 10);
          return;
        } else {
          this.$message({
            message: "操作成功",
            type: "success"
          });
        }

        setTimeout(() => {
          this.resetRuleForm();
        }, 0);
        this.queryList();
        this.queryOrderRefundRecord();
        this.detailOrder();
        // this.queryReturnGoods();
      }
    },
    reject(formName) {
      // this.$refs.textarea.focus();
      // if(!this.selectRadio && this.status===2){
      //   this.$message({
      //     message: "请先选择退货地址",
      //     type: "warning"
      //   });
      //   return false;
      // }
      console.log("发送",this.selectRadio);
      document.getElementById("btn").blur();
      console.log("this.status: ", this.status);
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.status <= 4) {
            let params = {
              orderRefundId: this.orderRefundId,
              confirmReturnAmount: this.confirmReturnAmount,
              confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
              confirmReturnPackageMoney: this.confirmReturnPackageMoney,
              confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
              returnIntegral: this.returnIntegral,
              confirmReturnIntegral: this.confirmReturnIntegral,
              status: this.status,
              receiptSn: this.receiptSn,
              orderGoodsId: this.orderGoodsId,
              centerId: this.detailsOrder.order.centerId,
              refundReceiverName: this.selectRadioRow.receiverName,
              refundReceiverMobile: this.selectRadioRow.receiverMobile,
              refundReceiverAddress: this.selectRadioRow.receiverAddress,
            };
            if (this.refundAgain === "yes") {
              params.refundAgain = "yes";
            }
            Object.assign(params, this.ruleForm);
            params.returnNumber = Number(this.ruleForm.returnNumber);
            return this.$store.dispatch("orderReturnUpd", params).then(res => {
              const { code, result, inMsg, errMsg } = res;
              if (code === "0") {
                this.detailsVisible = false;
                this.returnAddressVisible = false;
                if (result === "error") {
                  this.$message({
                    message: "该商品已经核定售后金额",
                    type: "warning"
                  });
                } else if (inMsg === "prepayCardUsed") {
                  //储值卡已被使用过
                  this.prepayCardUsedVisible = true;
                  this.prepayCardUsedErrmag = errMsg;
                  this.memberRelModelList = result.memberRelModelList;
                  setTimeout(() => {
                    this.$message({
                      message: errMsg,
                      type: "warning"
                    });
                  }, 10);
                  return;
                } else {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                }

                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.queryList();
                this.queryOrderRefundRecord();
                this.detailOrder();
                // this.queryReturnGoods();
              }
            });
          } else {
            let params = {
              orderRefundId: this.orderRefundId,
              status: this.status,
              confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
              confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
              confirmReturnPackageMoney: this.confirmReturnPackageMoney,
              confirmReturnAmount: this.confirmReturnAmount,
              confirmReturnIntegral: this.confirmReturnIntegral,
              centerId: this.detailsOrder.order.centerId,
            };
            Object.assign(params, this.ruleForm);
            return this.$store.dispatch("orderReturnUpd", params).then(res => {
              if (res.code === "0") {
                this.detailsVisible = false;
                this.returnAddressVisible = false;
                if (res.result === "error") {
                  this.$message({
                    message: "该商品已审核！",
                    type: "warning"
                  });
                } else {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                }

                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.queryList();

                this.queryOrderRefundRecord();
                this.detailOrder();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    async undo(row) {
      const { code } = await this.$store.dispatch("cancleRefundInfo", {
        orderGoodsId: row.orderGoodsId,
        orderRefundId: row.orderRefundId
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
        this.dialogVisible = false;
      }
    },
    //代用户确认退款
    async makeSenseDialog(row) {
      this.makeSenseVisible = true;
      this.row = row;
    },
    async makeSense(row) {
      const { code } = await this.$store.dispatch("refundMakeSense", {
        orderGoodsId: row.orderGoodsId,
        orderRefundId: row.orderRefundId,
        receiptSn: row.receiptSn,
        operationRemark: this.ruleForm.operationRemark
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
      }
      this.queryReturnGoods();
      this.queryOrderRefundRecord();
      this.ruleForm.operationRemark = "";
      this.makeSenseVisible = false;
    },
    bohui(index) {
      if (!this.returnGoods[index].confirmReturnAmount) {
        this.confirmReturnAmount = 0;
      } else {
        this.confirmReturnAmount = this.returnGoods[index].confirmReturnAmount;
      }

      this.confirmReturnDeliverMoney =
        this.returnGoods[index].confirmReturnDeliverMoney === ""
          ? 0
          : this.returnGoods[index].confirmReturnDeliverMoney;
      this.confirmReturnPackageMoney =
        this.returnGoods[index].confirmReturnPackageMoney === ""
          ? 0
          : this.returnGoods[index].confirmReturnPackageMoney;
      this.confirmReturnPrepayCardMoney =
        this.returnGoods[index].confirmReturnPrepayCardMoney === ""
          ? 0
          : this.returnGoods[index].confirmReturnPrepayCardMoney;

      this.returnIntegral = +this.returnGoods[index].returnIntegral || 0;
      this.confirmReturnIntegral =
        +this.returnGoods[index].confirmReturnIntegral || 0;
      this.detailsVisible = true;
      this.status = 8;
    },
    jixu(index) {
      this.refundAgain = "yes";
      this.refundAgainAmount = this.returnGoods[index].confirmReturnAmount;
      this.returnGoods[index].status = 1;
      this.returnGoods[index].returnAmount = formatFloat(
        this.returnGoods[index].returnAmount -
          this.returnGoods[index].confirmReturnAmount,
        2
      );
      this.returnGoods[index].confirmReturnAmount = JSON.parse(
        JSON.stringify(this.returnGoods[index].returnAmount)
      );
      this.returnGoods[index].returnDeliverMoney = formatFloat(
        this.returnGoods[index].returnDeliverMoney -
          this.returnGoods[index].confirmReturnDeliverMoney,
        2
      );
      this.returnGoods[index].confirmReturnDeliverMoney = JSON.parse(
        JSON.stringify(this.returnGoods[index].returnDeliverMoney)
      );
      this.returnGoods[index].confirmReturnAmount = JSON.parse(
        JSON.stringify(this.returnGoods[index].returnAmount)
      );
      this.returnGoods[index].returnPackageMoney = formatFloat(
        this.returnGoods[index].returnPackageMoney -
          this.returnGoods[index].confirmReturnPackageMoney,
        2
      );
      this.returnGoods[index].confirmReturnPackageMoney = JSON.parse(
        JSON.stringify(this.returnGoods[index].returnPackageMoney)
      );
    },
    shownumber(index){
      
      // console.log(112);
      this.ruleForm.returnNumber = '0';
      this.returnNumberVisible = true;
      this.currnetIndex = index;
      // if(this.returnGoods[index].returnType === "refund")
      // {
      //   this.consent2(index);
      // }else{
      //   this.detailsVisible = true;
      // }
    },
    handleInput(value) {
      console.log(typeof(value));
      // 使用正则表达式匹配只有数字的字符串，并且不包含负号
      const regex = /^[0-9]\d*$/;
      // 如果输入的值不符合正则表达式，则将其重置为初始值
      if (!regex.test(value)) {
        this.ruleForm.returnNumber = this.ruleForm.returnNumber.substring(0, this.ruleForm.returnNumber.length - 1);
      }
    },
    makeSureNumber(index){
      // console.log(this.returnGoods[index]);
      if (Number(this.ruleForm.returnNumber) > 0 && Number(this.ruleForm.returnNumber) <= Number(this.returnGoods[index].goodsNumber)) {
        this.returnNumberVisible = false;
        if(this.returnGoods[index].returnType === "refund")
        {
          this.consent2(index);
        }else{
          this.detailsVisible = true;
        }
      }else{
          this.$message({
            message: "请填写正确的商品数量",
            type: "warning"
          });
      }
    },
    consent(index) {
      if (this.queryConfigFlag) {
        if (
          (this.returnGoods[index].returnType !== "deliver" &&
            this.returnGoods[index].confirmReturnAmount === "") ||
          this.returnGoods[index].confirmReturnDeliverMoney === "" ||
          this.returnGoods[index].confirmReturnPackageMoney === ""
        ) {
          this.$message({
            message: "请填写确认退款金额",
            type: "warning"
          });
        } else {
          if (
            +this.returnGoods[index].confirmReturnAmount >
              +this.returnGoods[index].returnAmount ||
            +this.returnGoods[index].confirmReturnDeliverMoney >
              +this.returnGoods[index].returnDeliverMoney ||
            +this.returnGoods[index].confirmReturnPackageMoney >
              +this.returnGoods[index].returnPackageMoney ||
            +this.returnGoods[index].confirmReturnPrepayCardMoney >
              +this.returnGoods[index].returnPrepayCardMoney
          ) {
            this.$message({
              message: "退款金额不能大于实付金额",
              type: "warning"
            });
          } else {
            if (
              +this.returnGoods[index].confirmReturnAmount < 0 ||
              +this.returnGoods[index].confirmReturnDeliverMoney < 0 ||
              +this.returnGoods[index].confirmReturnPackageMoney < 0 ||
              +this.returnGoods[index].confirmReturnPrepayCardMoney < 0
            ) {
              this.$message({
                message: "请输入大于0的金额",
                type: "warning"
              });
            } else {
              this.confirmReturnAmount = +this.returnGoods[index]
                .confirmReturnAmount;
              this.confirmReturnDeliverMoney = +this.returnGoods[index]
                .confirmReturnDeliverMoney;
              this.confirmReturnPackageMoney = +this.returnGoods[index]
                .confirmReturnPackageMoney;
              this.confirmReturnPrepayCardMoney = +this.returnGoods[index]
                .confirmReturnPrepayCardMoney;
              this.returnIntegral = +this.returnGoods[index].returnIntegral;
              this.confirmReturnIntegral = +this.returnGoods[index]
                .confirmReturnIntegral;
              if (this.returnGoods[index].status == 1) {
                this.status = 2;
              } else if (this.returnGoods[index].status == 2) {
                this.status = 4;
              }
              // if (this.returnType === "money") {
              //   if (this.returnGoods[index].status == 1) {
              //     this.status = 2;
              //   } else if (this.returnGoods[index].status == 2) {
              //     this.status = 4;
              //   }
              // } else if (this.returnType === "refund") {
              //   if (this.returnGoods[index].status == 1) {
              //     this.status = 2;
              //   } else if (this.returnGoods[index].status == 2) {
              //     this.status = 4;
              //   }
              // }
              if (
                +this.returnGoods[index].confirmReturnAmount <
                  +this.returnGoods[index].returnAmount ||
                +this.returnGoods[index].confirmReturnDeliverMoney <
                  +this.returnGoods[index].returnDeliverMoney ||
                +this.returnGoods[index].confirmReturnPackageMoney <
                  +this.returnGoods[index].returnPackageMoney ||
                +this.returnGoods[index].confirmReturnPrepayCardMoney <
                  +this.returnGoods[index].returnPrepayCardMoney
              ){
                this.shownumber(index);
              } else {
                this.ruleForm.returnNumber = this.returnGoods[index].goodsNumber;
                this.makeSureNumber(index);
              }
            }
          }
        }
      } else {
        if (
          (this.returnGoods[index].returnType !== "deliver" &&
            this.returnGoods[index].confirmReturnAmount === "") ||
          this.returnGoods[index].confirmReturnDeliverMoney === "" ||
          this.returnGoods[index].confirmReturnPackageMoney === ""
        ) {
          this.$message({
            message: "请填写确认退款金额",
            type: "warning"
          });
        } else {
          let goodsTotal = 0;
          let prepayCardTotal = 0;
          this.returnGoods.forEach(v => {
            if (v.status !== 8) {
              goodsTotal += v.confirmReturnAmount * 1;
              prepayCardTotal += v.confirmReturnPrepayCardMoney * 1;
            }
          });
          goodsTotal = goodsTotal.toFixed(2);
          prepayCardTotal = prepayCardTotal.toFixed(2);
          let goodsLimit = (
            this.detailsOrder.order.actuallyPrice -
            (this.detailsOrder.order.deliverMoney -
              this.detailsOrder.order.deliverCouponMoney)
          ).toFixed(2);

          if (this.refundAgain === "yes") {
            goodsLimit = formatFloat(
              goodsLimit - this.refundAgainAmount,

              2
            );
          }
          console.log("goodsLimit: ", goodsLimit);
          console.log("goodsTotal: ", goodsTotal);
          if (
            new Number(goodsTotal) > new Number(goodsLimit) ||
            prepayCardTotal > this.detailsOrder.order.prepayMoney ||
            this.returnGoods[index].confirmReturnDeliverMoney >
              +this.returnGoods[index].returnDeliverMoney ||
            this.returnGoods[index].confirmReturnPackageMoney >
              +this.returnGoods[index].returnPackageMoney
          ) {
            this.$message({
              message: "退款金额不能大于实付金额",
              type: "warning"
            });
          } else {
            if (
              +this.returnGoods[index].confirmReturnAmount < 0 ||
              +this.returnGoods[index].confirmReturnDeliverMoney < 0 ||
              +this.returnGoods[index].confirmReturnPackageMoney < 0 ||
              +this.returnGoods[index].confirmReturnPrepayCardMoney < 0
            ) {
              this.$message({
                message: "请输入大于0的金额",
                type: "warning"
              });
            } else {
              this.confirmReturnAmount = +this.returnGoods[index]
                .confirmReturnAmount;
              this.confirmReturnDeliverMoney = +this.returnGoods[index]
                .confirmReturnDeliverMoney;
              this.confirmReturnPackageMoney = +this.returnGoods[index]
                .confirmReturnPackageMoney;
              this.confirmReturnPrepayCardMoney = +this.returnGoods[index]
                .confirmReturnPrepayCardMoney;
              this.returnIntegral = +this.returnGoods[index].returnIntegral;
              this.confirmReturnIntegral = +this.returnGoods[index]
                .confirmReturnIntegral;
              if (this.returnGoods[index].status == 1) {
                this.status = 2;
              } else if (this.returnGoods[index].status == 2) {
                this.status = 4;
              }
              // if (this.returnType === "money") {
              //   if (this.returnGoods[index].status == 1) {
              //     this.status = 2;
              //   } else if (this.returnGoods[index].status == 2) {
              //     this.status = 4;
              //   }
              // } else if (this.returnType === "refund") {
              //   if (this.returnGoods[index].status == 1) {
              //     this.status = 2;
              //   } else if (this.returnGoods[index].status == 2) {
              //     this.status = 4;
              //   }
              // }
              if (
                +this.returnGoods[index].confirmReturnAmount <
                  +this.returnGoods[index].returnAmount ||
                +this.returnGoods[index].confirmReturnDeliverMoney <
                  +this.returnGoods[index].returnDeliverMoney ||
                +this.returnGoods[index].confirmReturnPackageMoney <
                  +this.returnGoods[index].returnPackageMoney ||
                +this.returnGoods[index].confirmReturnPrepayCardMoney <
                  +this.returnGoods[index].returnPrepayCardMoney
              ){
                this.shownumber(index);
              } else {
                this.ruleForm.returnNumber = this.returnGoods[index].goodsNumber;
                this.makeSureNumber(index)
              }
              // this.shownumber(index);
            }
          }
        }
      }
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: queryAll ? 1 : this.currentPage,
        refundMode:''
      };
      this.activeTab==0 ? params.refundMode = "" : params.refundMode = "third";
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";

      // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //   : "";

      Object.assign(params, searchCondition);
      this.setParamsCookie();

      const actionName = queryAll
        ? "queryALLOrderReturnList"
        : "queryOrderReturnList";
      return this.$store.dispatch(actionName, params);
    },
    setParamsCookie() {
      setCookie({
        key: "afterSaleListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "afterSaleListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.searchCondition.queryTimeType =
          this.searchCondition.queryTimeType === "refundTime"
            ? "refundTime"
            : "returnSendTime";
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async orderDetail(row) {
      if(row.expressSn){
        this.expressSn = row.expressSn
      }
      if(row.expressSenderPhone){
        this.expressSenderPhone = row.expressSenderPhone;
      }else{
        this.expressSenderPhone = row.memberMobile;
      }
      this.logisticsInfoVisible = true;
      const { storeCode } = getLoginUser();
      const { code, result } = await this.$store.dispatch("getExpressInfo", {
        storeCode,
        expressSn : row.expressSn,
        expressSenderPhone: row.expressSenderPhone,
      });
      if (code === "0") {
        if(result.state==='201'){
          this.$message({
            message: result.message,
            type: "warning"
          });
          return false;
        }
        this.expressInfoResult = result
      }
    },
    storeAddressAdd(){
      this.returnAddressAddVisible = true;
    },
    async storeAddressInfoAdd(formName){
      const valid = await this.$refs[formName].validate();
      if(valid){
        let params = this.receiverList;
        const { code, result } = await this.$store.dispatch("storeAddressInfoAdd", params);
        if(code === "0"){
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.storeAddressInfoQueryPageList();
          this.returnAddressAddVisible = false;
        }
      }
    },
    async storeAddressInfoQueryPageList (){
      let params = {
        enabledState: "yes"
      }
      const { code, result } = await this.$store.dispatch("storeAddressInfoQueryPageList", params);
      if(code === "0"){
        this.storeAddressInfoList = result.records;
      }
    },
    async storeAddressRemoves(row){
      const result = await this.$confirm("是否删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        let params = {
          id:row.id
        };
        const { code, result } = await this.$store.dispatch("storeAddressInfoDelete", params);
        if(code === "0"){
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.storeAddressInfoQueryPageList();
        }
      }
    },
    consent2(index) {
      this.row = index;
      this.returnAddressVisible = true;
      this.storeAddressInfoQueryPageList();
    },
    changeSelectRadio(item){
      this.selectRadioRow = item;
    },
    async applyReturnGoods(item){
      console.log("item:",item);
      const { storeCode } = getLoginUser();
      const { code, result } = await this.$store.dispatch("applyReturnGoods", {
        storeCode,
        orderRefundId: item.orderRefundId,
        receiptSn: item.receiptSn,
      });
      if(code==="0"){
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.toDetails(this.nowRow);
      }
    },
  }
};
</script>
<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}

.el-table .tuikuan {
  background: rgba(255, 240, 240, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  z-index: 9999999;
}
.content {
  .el-step.is-center .el-step__description {
    padding: 0;
  }
}
</style>
<style scoped lang="scss">
.only-tuikuan {
  opacity: 0.3;
  // background: rgba(255, 255, 255, 1);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.tuikuan {
  background: rgba(255, 240, 240, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  z-index: 9999999;
}
.warning-tuikuan {
  position: absolute;
  left: 0;
  top: 0;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}

.content {
  margin: -20px;
  .progress {
    background: #f7f7f7;
    padding: 20px 0;
  }
}
.info-list {
  // padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .text{
    line-height: 28px;
  }
}

.content-item {
  line-height: 25px;
  color: #222;
  .info {
    color: #666666;
  }
}
.expressSn{
  float: right;
  line-height: 28px;
  span{
    color: #0081E5;
    margin-left: 20px;
    cursor: pointer;
  }
}
.track-rcol {
  .track-list {
    position: relative;
  }
  ul li {
    list-style: none;
    font-size: 14px;
    line-height: 14px;
  }
  ul {
    padding-left: 1.5rem;
  }
  .track-list li {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 14px;
    border-left: 1px solid #d9d9d9;
    color: #999;
  }
  .track-list li.first {
    color: red;
    padding-top: 0;
    // width: 100%;
    text-align: left;
    border-left: 1px solid #d9d9d9;
  }
  .track-list li .node-icon {
    position: absolute;
    left: -5.5px;
    border-radius: 0.25rem;
    width: 0.5rem;
    height: 0.5rem;
    top: 4px;
    background-color: #999999;
  }
  .track-list li.first .node-icon {
    background-position: 0-72px;
    background-color: red;
    width: 10px;
    z-index: 2;
    height: 10px;
    position: absolute;
    left: -5px;
    top: 0;
    border-radius: 0.5rem;
  }
  .track-list li .time {
    // margin-right: 20px;
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: middle;
    background-color: white;
    color: #999;
    width: 100%;
    text-align: left;
  }
  .track-list li .txt {
    position: relative;
    display: inline-block;
    vertical-align: top;
    color: #999;
  }
  .track-list li.first .time {
    text-align: left;
    width: 94%;
    color: red;
  }
  .track-list li.first .txt {
    color: red;
    text-align: left;
    width: 94%;
  }
  .track-list li.finall {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 18px;
    border-color: white;
    border-left: 1px solid #ffffff;
    color: #999;
  }
  .track-list li.finall .div-spilander {
    width: 1px;
    position: absolute;
    position: absolute;
    left: -1.5px;
    height: 0.5rem;
    background-color: #d9d9d9;
  }
}
.from-tips{
  line-height: 20px;
}
.red{
  color: red;
}
.mop-cancel-tips {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
}
.mop-cancel-success {
  background-color: #f0f9eb;
  border: 1px solid #67c23a;
  color: #606266;
  width: fit-content;
}
.mop-cancel-fail {
  background-color: #fef0f0;
  border: 1px solid #f56c6c;
  color: #606266;
  width: fit-content;
}
.mop-refund-no {
  color: #409eff;
}
.mop-fail-text {
  color: #f56c6c;
  font-weight: bold;
}
.mop-retry-btn {
  margin-left: 10px;
}
</style>
